import PropTypes from 'prop-types';
import { WORKSPACE_STATUS } from './constants';

const slackWorkspaceShape = PropTypes.shape({
    team_id: PropTypes.string.isRequired,
    team_name: PropTypes.string.isRequired,
    status: PropTypes.oneOf(Object.values(WORKSPACE_STATUS)).isRequired,
    needs_reinstall: PropTypes.bool,
});

export const slackAgentStatusShape = PropTypes.shape({
    available: PropTypes.bool.isRequired,
    workspace: slackWorkspaceShape,
    linked_slack_user_id: PropTypes.string,
});

export const pendingSlackLinkShape = PropTypes.shape({
    team_id: PropTypes.string.isRequired,
    team_name: PropTypes.string.isRequired,
    slack_user_id: PropTypes.string.isRequired,
    confirm_token: PropTypes.string.isRequired,
});
